
import { __ } from '@wordpress/i18n';
import { useState,useEffect } from '@wordpress/element';
import {Button,
    __experimentalHStack as HStack,
    __experimentalVStack as VStack,
    __experimentalText as Text,
    __experimentalGrid as Grid,
    __experimentalToggleGroupControl as ToggleGroupControl,__experimentalToggleGroupControlOptionIcon as ToggleGroupControlOptionIcon

} from '@wordpress/components';
import { Icon } from '@wordpress/components';
import { settings } from '@wordpress/icons';
import { VayuBlocksDevice,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';
import { VayuBlocksRangeControl } from './range-controls.js';
import { VayuBlocksUnitControl } from './unit-controls.js';


export function VayuBlocksRangeUnitControl({
    onChange,
    attribute={key, value},
    min=0,
    max=10,
    label="Range Unit Control",
    initialPosition=0,
    unitControl=true
}){ 
  const getView = VayuBlocksDevice(); 

  const currentValue = attribute.value?.[getView] ?? '0px';
  // Initial values
const { value: initialValue, unit: initialUnit } = typeof currentValue === 'string' ? splitValueAndUnit(currentValue) : { value: 0, unit: 'px' };

// ✅ Initialize state
const [unitInt, setUnitInt] = useState(initialValue);
const [unit, setUnit] = useState(initialUnit);
 const [ isUnit, setIsUnit ] = useState(true);


 useEffect(() => {
  // Update the state when the prop changes
  const { value, unit } = splitValueAndUnit(currentValue);
  
  setUnitInt(value);
  setUnit(unit);
}, [currentValue]);

  function splitValueAndUnit(str="0px") {
    if (typeof str === 'string') {
      const match = str.match(/^(-?\d*\.?\d+)([a-z%]*)$/i);
      if (!match) return null;

      return {
        value: match ? parseFloat(match[1]) : 0,
        unit: match ? match[2] : 'px',
      };
    }

  }

      const [firstTablet, setfirstTablet] = useState(false);
      const [firstDesktop, setfirstDesktop] = useState(false);

const handelUnitRangeChange = (neValue) => {
  const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

  let updateValue = `${unitInt}${unit}`;
  
  if (typeof neValue !== 'string') {
    updateValue = `${neValue}${unit}`; // unit value
    setUnitInt(parseFloat(neValue)); // numeric value
 }else{
  const splitUnit = splitValueAndUnit(neValue);
  updateValue = `${splitUnit.value}${splitUnit.unit}`; // unit value
  setUnit(splitUnit.unit); // unit value
  setUnitInt(splitUnit.value); // numeric value
  }

      const attr = attribute.value;
      const key = attribute.key;
      const isFirstRun = attr?.[getView] === undefined;

      if(getView==='Desktop'){

        if (isFirstRun || firstDesktop) {

          onChange(key, { Desktop: updateValue, Tablet: updateValue, Mobile: updateValue });
          setfirstTablet(true);
          setfirstDesktop(true);
          localStorage.setItem('firstTablet', true);

      }else{
         onChange(key, { ...attr, Desktop: updateValue });
      }


      }else if(getView==='Tablet'){

            if (isTabletFirstRun) {
              localStorage.removeItem('firstTablet');
             onChange(key, { ...attr, Tablet: updateValue, Mobile: updateValue });
              setfirstTablet(true);
              setfirstDesktop(false);

          }else{
              onChange(key, { ...attr, Tablet: updateValue });
          }


    }else if(getView==='Mobile'){

      setfirstTablet(false);
      setfirstDesktop(false);
      onChange(key, { ...attr, Mobile: updateValue });
        }

  };

   

return(<>
<VStack>
<Text>{<VayuBlocksDeviceControl label={__(label)} classname='bold' />}</Text>

</VStack>
<VStack className={"vayu-blocks-range-unit-control"}>
    <HStack>
  
    {isUnit ? (
  <>
    <div style={{ width: '90%' }}>
      <VayuBlocksRangeControl 
        onChange={(value)=> handelUnitRangeChange(value)}
        min={min}
        max={max}
        withInputField={false}
        attribute={{key: false, value: unitInt}}
        label=''
      />
    </div>
  </>
) : (<>
  <VayuBlocksUnitControl 
  onChange={(value)=> handelUnitRangeChange(value)}
    attribute={{key: false, value: `${unitInt}${unit}`}}
    min={min}
    max={max}
    label=''
  />
  <div style={{ width: '80%' }}>
      <VayuBlocksRangeControl 
        onChange={(value)=> handelUnitRangeChange(value)}
        marks={false}
        withInputField={false}
        attribute={{key: false, value: unitInt}}
        min={min}
        max={max}
        label=''
      />
    </div>
 
</>

)}

<div className="vayu-blocks-range-unit-toggle">
    <ToggleGroupControl
      __next40pxDefaultSize
      __nextHasNoMarginBottom
      isDeselectable
      label=""
      onChange={() => setIsUnit(!isUnit)}
    >
      <ToggleGroupControlOptionIcon
        icon={<Icon icon={settings} />}
        label="changetype"
      />
    </ToggleGroupControl>
  </div>
      </HStack>
      </VStack></>)                  
}